import * as React from 'react';
import { Header1 } from '@cian/ui-kit/typography';
import * as styles from './styles.css';

export interface IFullscreenGalleryCategoryProps {
  title: React.ReactNode;
  children: React.ReactNode;
  name?: string;
}

export function Category({ title, children, name }: IFullscreenGalleryCategoryProps) {
  return (
    <div className={styles['container']}>
      <div id={name} className={styles['heading']}>
        <Header1 as={'h2'}>{title}</Header1>
      </div>
      <div className={styles['content']}>{children}</div>
    </div>
  );
}
